import React from "react";
import PropTypes from "prop-types";

import Translate from "utils/translate";

import styles from "./ChannelLabel.css";

const { t } = new Translate("Channels");

const ChannelLabel = (props) => (
  <div>
    {props.channel.company || props.channel.name}
    {props.channel.category ? (
      <span className={styles.category}>{t(`channelCategories.${props.channel.category}`)}</span>
    ) : null}
  </div>
);

ChannelLabel.propTypes = {
  channel: PropTypes.shape({
    name: PropTypes.string,
    company: PropTypes.string,
    category: PropTypes.string,
  }).isRequired,
};

export default ChannelLabel;
